/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Autoplay, Pagination } from "swiper/modules";
import { buildImageUrl } from "../theme1/utils/theme1Helpers";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

const HeroSection = ({ theme, apiBanners = [], storeData = {}, onOpenCart }) => {
  const activeBanners = (apiBanners || []).filter(b => b.active);
  const bannerImages = activeBanners.map(b => buildImageUrl(b.imageUrl));
  const canLoop = bannerImages.length > 1;

  return (
    <section className="container mx-auto px-6 py-12 md:py-20" dir="rtl">
      <div className="flex flex-col md:flex-row-reverse items-center justify-between gap-10 md:gap-20">

        {/* ====== 3D Coverflow Banner أكبر وأوتوماتيك ====== */}
        <div className="w-full md:w-1/2 relative mx-auto">
          {bannerImages.length > 0 ? (
            <Swiper
              effect={"coverflow"}
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={"auto"}
              spaceBetween={0} // الصور ملتصقة
              loop={canLoop}
              autoplay={canLoop ? {
                delay: 2000,
                disableOnInteraction: false,
                reverseDirection: true, // تتحرك بالعكس بعد كل دورة
              } : false}
              coverflowEffect={{
                rotate: 40,
                stretch: 0,
                depth: 150, // عمق مناسب للحجم الأكبر
                modifier: 1,
                slideShadows: false,
              }}
              pagination={{ clickable: true }}
              modules={[EffectCoverflow, Autoplay, Pagination]}
              className="hero-banner-swiper"
            >
              {bannerImages.map((img, idx) => (
                <SwiperSlide
                  key={idx}
                  className="flex justify-center items-center"
                  style={{ width: "200px", height: "250px" }} // حجم أكبر
                >
                  <img
                    src={img}
                    alt={`banner-${idx}`}
                    className="rounded-xl object-cover w-full h-full"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="w-full h-[250px] flex items-center justify-center text-gray-300 font-medium bg-gray-50 rounded-xl">
              لا توجد صور متوفرة
            </div>
          )}
        </div>

        {/* ====== Text Section ====== */}
        <div className="w-full md:w-1/2 flex flex-col items-center gap-6 text-center">
          <div className="max-w-xl w-full flex flex-col items-center gap-4">
            <h1 className="text-3xl sm:text-4xl md:text-6xl font-black text-gray-900 leading-[1.2] w-full">
              {storeData.storeName || "أفضل المنتجات، بأبسط تجربة"}
            </h1>
            <p className="text-gray-500 text-base sm:text-lg md:text-xl leading-relaxed w-full">
              {storeData.description || "اكتشف منتجات مختارة بعناية، توصيل سريع ودفع آمن."}
            </p>
            <div className="w-full flex justify-center mt-4">
              <button
                onClick={onOpenCart}
                className={`${theme.bg} ${theme.hover} text-white px-8 py-3 md:px-14 md:py-5 rounded-2xl font-extrabold text-base md:text-lg transition-all shadow-lg hover:shadow-2xl hover:-translate-y-1 active:scale-95`}
              >
                تسوق الآن
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
